import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Popconfirm, Table, TableColumnsType } from 'antd'

import { path, useColumnLocalSearch } from 'src/libs'
import { Guard } from 'src/features/session/guard'

import {
  useTicketsList,
  useTicketsListGate,
} from 'src/pages/worldCup2026/tickets/hooks'
import { changeStatusSubmit } from 'src/pages/worldCup2026/tickets/model'
import { Ticket } from 'src/pages/worldCup2026/tickets/types'
import { AddTicketsModal } from 'src/pages/worldCup2026/tickets/widgets'

export const TicketList = () => {
  const [isAddTicketsModalOpen, setIsAddTicketsModalOpen] = useState(false)
  const { tickets, loading } = useTicketsList()
  useTicketsListGate()

  const ticketSearch = useColumnLocalSearch<Ticket>({
    dataIndex: 'ticketID',
  })

  const userSearch = useColumnLocalSearch<Ticket>({
    dataIndex: 'userID',
    customRender: (highlightedValue, record) => (
      <Link
        to={path.clients.details(String(record.userID))}
        style={{ textDecoration: 'none' }}
        target="_blank"
      >
        {highlightedValue}
      </Link>
    ),
  })

  const columns: TableColumnsType<Ticket> = [
    {
      title: 'Ticket',
      dataIndex: 'ticketID',
      key: 'ticketID',
      sorter: (a, b) => a.ticketID - b.ticketID,
      ...ticketSearch,
    },
    {
      title: 'User ID',
      dataIndex: 'userID',
      key: 'userID',
      sorter: (a, b) => a.userID - b.userID,
      ...userSearch,
    },
    {
      title: 'Status',
      dataIndex: 'isUsed',
      filters: [
        {
          text: 'Reserved',
          value: false,
        },
        {
          text: 'Issues',
          value: true,
        },
      ],
      onFilter: (value, record) => record.isUsed == value,
      render: (isUsed) => {
        if (isUsed) {
          return 'Issued'
        }
        return 'Reserved'
      },
    },
    {
      title: 'Actions',
      fixed: 'right',
      width: 150,
      render: (item: Ticket) => {
        return (
          !item.isUsed && (
            <Guard permission="issue_ticket_wc26">
              <Popconfirm
                title="Issue a ticket"
                description="Are you sure you want to issue a ticket?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => {
                  changeStatusSubmit({ userID: item.userID })
                }}
              >
                <Button size="small" color="danger" variant="solid">
                  Issue a ticket
                </Button>
              </Popconfirm>
            </Guard>
          )
        )
      },
    },
  ]

  return (
    <>
      <Guard permission="reserve_ticket_wc26">
        <Button
          color="geekblue"
          type="primary"
          size="large"
          style={{ alignSelf: 'flex-start', marginBottom: 24 }}
          onClick={() => setIsAddTicketsModalOpen(true)}
        >
          Ticket reservation
        </Button>
      </Guard>
      <Table<Ticket>
        dataSource={tickets}
        bordered={true}
        className="overflow-auto"
        loading={loading}
        rowKey="ticketID"
        columns={columns}
        pagination={{
          showSizeChanger: true,
          total: tickets.length,
        }}
      />
      <AddTicketsModal
        isVisible={isAddTicketsModalOpen}
        onClose={() => setIsAddTicketsModalOpen(false)}
      />
    </>
  )
}
